import { useMutation } from '@tanstack/react-query';
import { errorHandler } from '@app/utils/errorHandler';
import { api } from '@app/utils/api';
import { PANEl_BASE_URL } from '@app/contstants/endpoints';
import { ServerError } from '@app/error/ServerError';

export const fetch = async ({ account }: { account: string }): Promise<void> => {
  try {
    await api.delete<void>(`${PANEl_BASE_URL}/accounts/accounts/${account}/`);
  } catch (e: any) {
    throw new ServerError(e.response.data.error);
  }
};

export const useDeleteAccount = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
